export default "__VITE_ASSET__BVBPOdip__"